import { useEffect } from 'react'

/**
 * Pose un `document.title` dédié le temps où le composant est monté, puis
 * restaure le titre précédent au démontage. Utilisé par les pages d'erreur
 * transverses (404/500) pour un `<title>` explicite (RGAA, repère onglet/SR).
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title
    document.title = title
    return () => {
      document.title = previous
    }
  }, [title])
}
